import ApiClientClass from '../../lib/api/ApiClient';
import { ApiClient } from '../../lib/api/ApiClient.types';

export const apiClient = new ApiClientClass() as unknown as ApiClient;
